// extracted by mini-css-extract-plugin
export default {"updatePasswordContainer":"UpdatePassword_updatePasswordContainer__gvoyi","message":"UpdatePassword_message__331f-"};